/*
 * Offer banner.
 *
 * @author Larry Ioannidis <larry@rakun.ie>
 * @author Konstantinos Pappas <konpap@pressidium.com>
 */

import Cookies from 'js-cookie';

/**
 * Return the difference in days between two dates.
 *
 * @param {Date} date1 Date to compare.
 * @param {Date} date2 Date to compare.
 *
 * @return {number} The difference in days between the two dates.
 */
const daysDiff = (date1, date2) => {
    const diff = date1.getTime() - date2.getTime();

    return Math.floor(diff / (1000 * 60 * 60 * 24));
}

/**
 * Initialize the promo countdown.
 *
 * @return {void}
 */
const initPromoCountdown = () => {
    const countdownElement = document.querySelector('#coupon-countdown');

    if (countdownElement === null) {
        // There is no countdown element, bail early
        return;
    }

    const expiryString = countdownElement.getAttribute('data-promo-expiry');

    if (!expiryString) {
        // There is no expiry date, bail early
        return;
    }

    const expiryDate = new Date(expiryString + 'Z');
    const now = new Date();

    const days = daysDiff(expiryDate, now);

    countdownElement.textContent = `${days} ${days === 1 ? 'Day' : 'Days'} left`;
};

/**
 * Set the coupon banner height as a CSS custom property.
 *
 * @param {number} height The height in pixels.
 * @return {void}
 */
const setCouponBannerHeight = (height) => {
    document.documentElement.style.setProperty('--coupon-banner-height', `${height}px`);
};

/**
 * Initialize the promo banner based on the user's previous interaction.
 *
 * @return {void}
 */
const initPromoBanner = () => {
    // Initialize the `coupon_storage` cookie
    if (!Cookies.get('coupon_storage')) {
        Cookies.set('coupon_storage', 'open');
    }

    // Hide the banner if the `coupon_storage` cookie is set to `closed`
    if (Cookies.get('coupon_storage') === 'closed') {
        document.getElementById('coupon').style.display = 'none';
        setCouponBannerHeight(0);
    } else {
        document.getElementById('coupon').style.display = 'block';
    }

    const dismissButton = document.querySelector('#coupon-dismiss');

    dismissButton.addEventListener('click', function () {
        const wrapper = document.querySelector('#coupon');

        // Set the `coupon_storage` to `closed` when the dismiss button is clicked
        Cookies.set('coupon_storage', 'closed', { expires: 1 });

        // Remove the resize event listener
        window.removeEventListener('resize', onResize);

        // Hide the banner
        wrapper.style.height = '0';
        setCouponBannerHeight(0);
    });
};

/**
 * Offer banner resize handler.
 *
 * @return {void}
 */
const onResize = () => {
  const wrapper = document.querySelector('#coupon');
  wrapper.style.height = 'auto';

  const wrapperHeight = wrapper.offsetHeight;
  wrapper.style.height = wrapperHeight + 'px';

  // Update the CSS custom property with the new height
  setCouponBannerHeight(wrapperHeight);
};

// Display the coupon banner if the user has not dismissed it before
document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('#coupon');

    if (wrapper === null) {
        // The coupon banner is not present on the page, bail early
        setCouponBannerHeight(0);
        return;
    }

    const wrapperHeight = wrapper.offsetHeight;
    wrapper.style.height = wrapperHeight + 'px';

    // Set the initial height as a CSS custom property
    setCouponBannerHeight(wrapperHeight);

    initPromoBanner();
    initPromoCountdown();
    onResize();

    window.addEventListener('resize', onResize);
});
